import { cva } from 'class-variance-authority'

export const optionButtonStyles = cva(
  `
    w-full
    text-left
    px-3
    py-2
    text-sm

    rounded
    hover:bg-[#f0fdf4]
    cursor-pointer
    flex
    items-center
    gap-2
    whitespace-nowrap
  `
)
